import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// report-common
import { getReportReducers } from '../../report-common';
// feature toll charges
import * as A from './actions';
//////////////////////////////////////////////////

const initial = {
  truckList: {},
  driverList: {},
  filterProps: [],
  truckGuid: null,
  driverGuid: null,
};

const {
  selectItem,
  setReports,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  setInitialStateOmitReport,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers(initial);

const setTruckGuid = (state, truckGuid) => P.$set('truckGuid', truckGuid, state);

const setDriverGuid = (state, driverGuid) => P.$set('driverGuid', driverGuid, state);

const updateTollChargeSuccess = (state, data) => {
  const { guid, truckGuid, driverGuid } = data;

  const { itemList, truckList, driverList } = state;

  const truck = R.pathOr(null, [truckGuid], truckList);
  const driver = R.pathOr(null, [driverGuid], driverList);

  const tollCharge = R.mergeRight(
    R.pathOr({}, [guid], itemList),
    {
      truck,
      driver,
      truckGuid,
      driverGuid,
    },
  );

  return P.$set(`itemList.${guid}`, tollCharge, state);
};

const receivedDriverListSuccess = (state, data) => {
  if (G.isNilOrEmpty(data)) return state;

  const indexedDriverList = R.indexBy(R.prop(GC.FIELD_GUID), data);

  return P.$set('driverList', indexedDriverList, state);
};

const getTruckListSuccess = (state, data) => {
  if (G.isNilOrEmpty(data)) return state;

  const indexedTruckList = R.indexBy(R.prop(GC.FIELD_GUID), data);

  return P.$set('truckList', indexedTruckList, state);
};

const setAdditionalSearchCriteria = (state, data) => (
  P.$set('additionalSearchCriteria', data, state)
);

export default createReducer({
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setTruckGuid]: setTruckGuid,
  [A.setDriverGuid]: setDriverGuid,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.getTruckListSuccess]: getTruckListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.updateTollChargeSuccess]: updateTollChargeSuccess,
  [A.receivedDriverListSuccess]: receivedDriverListSuccess,
  [A.setInitialStateOmitReport]: setInitialStateOmitReport,
  [A.setAdditionalSearchCriteria]: setAdditionalSearchCriteria,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
}, initialState);
